// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__8i_Li","actions":"GroupTable_actions__3n09M","deleteModalFooter":"GroupTable_deleteModalFooter__2VCIR"};